import { Component, Input, OnInit } from '@angular/core';
import { Integration } from 'src/app/shared/models/integration.model';

@Component({
  selector: 'app-help-amazon-spapi-identity',
  templateUrl: './help-amazon-spapi-identity.component.html'
})
export class HelpAmazonSpapiIdentityComponent implements OnInit {
  @Input() integration: Integration;

  constructor() { }

  ngOnInit(): void {
  }


}
